<template>
	<div v-if="shouldRender">
	<div v-if="good_detail" class="gd">
		<!-- <naviBack title="" type="nav1" background="#FFFFFF"  /> -->
		<van-swipe :autoplay="5000" :show-indicators="false">
			<van-swipe-item v-for="(item_sw,index_sw) in good_detail.thumbs_arr" :key="'sw'+index_sw">
				<van-image class="gd_swiper" fit="cover" :src="item_sw" />
			</van-swipe-item>
		</van-swipe>
		<div class="gd_body">
			<div class="gd_body_title font_weight white_space">{{good_detail.goods_name}}</div>
			<div class="gd_body_address">
				<div class="gd_body_address_title white_space">{{good_detail.venue_info.venue_name}}</div>
				<div @click="openMap()" class="gd_body_address_stitle">
					<div class="gd_body_address_stitle_1 white_space">{{good_detail.venue_info.address}}</div>
					<!-- <div class="gd_body_address_stitle_2 white_space2">2.3km</div> -->
				</div>
			</div>
			<div v-if="good_detail.venue_info.introduce_content" class="gd_body_desc">
				<div class="gd_body_desc_title font_weight">酒店介绍</div>
				<div class="gd_body_desc_conte" v-html="good_detail.venue_info.introduce_content"></div>
			</div>
			<div v-if="good_detail.rules_arr && good_detail.rules_arr.length>0" class="gd_body_rule">
				<div v-for="(item,index) in good_detail.rules_arr" :key="'rule'+index" class="gd_body_rule_item">
					<div class="gd_body_rule_item_title font_weight">
						{{item.name=='note_to_book'?'预约须知':''}}
						<!-- {{item.name=='note_to_buy'?'购买须知':''}} -->
						{{item.name=='note_to_refund'?'退订规则':''}}
						<!-- {{item.name=='use_flow'?'使用流程':''}}
						{{item.name=='validate_content'?'有效期':''}} -->
					</div>
					<div class="gd_body_rule_item_stitle" v-html="item.content"></div>
				</div>
			</div>
			
			<div v-if="good_detail.content" class="gd_body_rule">
				<div class="gd_body_rule_item">
					<div class="gd_body_rule_item_title font_weight">商品介绍</div>
					<div class="gd_body_rule_item_stitle" v-html="good_detail.content"></div>
				</div>
			</div>
			
		</div>
		<div class="gd_bottom">
			<div class="gd_bottom_left flex_center_end">
				<div class="gd_bottom_left_1">¥</div>
				<div class="gd_bottom_left_2">{{good_detail.price}}</div>
				<div class="gd_bottom_left_1">/次</div>
				<div class="gd_bottom_left_3">门市价¥{{good_detail.market_price}}</div>
			</div>
			<div @click="openCreateOrder()" class="gd_bottom_right flex_center">立即预约</div>
		</div>
		
		<bookTime ref="bookTime" :good_detail="good_detail" @updataBookTime="updataBookTime" />
		<createOrder ref="openCreateOrder" 
		:good_detail="good_detail"
		:book_date_info="book_date_info" 
		:user_info="user_info" 
		:max_guest_num="max_guest_num" 
		:guest="guest" 
		@openTime="openTime" 
		@addGuest="addGuest" 
		@deleteGuest="deleteGuest"/>
		
	</div>
	</div>
</template>
<script>
	import naviBack from '../components/navi_back.vue';
	import bookTime from '../components/book_time.vue';
	import createOrder from '../components/create_order.vue';
	import {
		datePrintStr
	} from "../lib/utils.js"
	
	export default {
		components: {
			naviBack,bookTime,createOrder
		},
		data() {
			return {
				shouldRender: true,
				goodsId:'',
				good_detail:null,
				book_date_info:null,//预约日期信息
				user_info:null,
				guest: [], //嘉宾列表
				max_guest_num: 1, //最大可约人数
			}
		},
		watch: {
		    $route() {
		      // 路由变化时更新渲染状态
		      this.shouldRender = false
		      this.$nextTick(() => {
		        this.shouldRender = true
		      })
		    }
		  },
		created() {
			// location.reload()
			this.goodsId=''
			this.good_detail=null
			this.$loading('正在加载中...');
			this.goodsId = this.$route.params.goods_id
			this.getDetail()
			this.getUserInfo()
		},
		methods: {
			openMap(){
				console.log(this.good_detail);
				var lat=this.good_detail.venue_info.lat
				var lng=this.good_detail.venue_info.lon
				var encodeName=encodeURIComponent(this.good_detail.venue_info.venue_name)
				var encodeAddr=encodeURIComponent(this.good_detail.venue_info.address)
				
				// var url= `https://uri.amap.com/marker?position=${lng},${lat}&name=${encodeName}&address=${encodeAddr}&coordinate=gaode&callnative=0`
				// var url= `https://uri.amap.com/marker?position=${lng},${lat}&name=${encodeName}&coordinate=gaode&callnative=1&zoom=16&callnative=0`
				// var url=`https://uri.amap.com/marker?position=${lng},${lat}&name=${encodeName}&coordinate=gaode&callnative=0&hideNav=1&zoom=17&hideRoute=1&hideControl=1&navi=0`
				var url=`https://uri.amap.com/marker?position=${lng},${lat}&name=${encodeName}&showInfo=0&coordinate=gaode&callnative=0&hideNav=1&zoom=17&hideRoute=1&hideControl=1&navi=0&hideInfo=1`
				
				// var url= `http://api.map.baidu.com/marker?location=${lat},${lng}&title=${encodeName}&content=${encodeName}&output=html&src=vue2-h5&zoom=16`
				// var url= `http://api.map.baidu.com/marker?location=${lat},${lng}&title=${encodeName}&output=html&src=vue2-h5&zoom=17&noNav=1`
				// var url= `http://api.map.baidu.com/marker?location=${lat},${lng}&title=${encodeName}&output=html&src=vue2-h5&zoom=17&noNav=1`
				// var url = `https://api.map.baidu.com/marker?location=${lat},${lng}&title=${encodeName}&content=${encodeAddr}&zoom=17&output=html&tn=B_NORMAL_MAP&devtype=web&src=webapp&route=0&nav=0&zoomBtn=0&locationBtn=0&scale=0&share=0&poi=0&infoWindow=0&drag=0&scrollwheel=0&appname=web`;
				// var url = `https://api.map.baidu.com/marker?location=${lat},${lng}&title=${encodeURIComponent(encodeName)}&content=${encodeURIComponent(encodeAddr)}&zoom=15&output=html&tn=B_NORMAL_MAP&devtype=web&src=webapp&route=0&nav=0&zoomBtn=0&locationBtn=0&scale=0&share=0&poi=1&infoWindow=0&drag=0&scrollwheel=0&appname=web`;
				// var url=`https://api.map.baidu.com/marker?location=${lat},${lng}&title=${encodeName}&output=html&coord_type=gcj02ll&hideInfoWindow=1&zoom=17&hideNav=1&hideControl=1`
				
				// var url= `https://apis.map.qq.com/uri/v1/marker?marker=coord:${lat},${lng};title:${encodeName};type:marker&referer=vue2-h5&zoom=17&nav=0`
				
				window.location.href=url
			},
			getUserInfo() {
				var $this = this
				var param = {}
				var qs = require('qs');
				let url = this.api.userApi.index_getUserInfo
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						console.log(res)
						$this.user_info = res.data
					}).catch((error) => {
						console.warn(error)
						$this.$toast(error.msg ? error.msg : error.message);
					})
			},
			getDetail() {
				var $this = this
				var param = {
					goodsId: this.goodsId
				}
				var qs = require('qs');
				let url = this.api.userApi.index_getGoodsInfo
				this.axios.post(url, qs.stringify(param))
					.then((res) => {
						// console.log(res)
						res.data.thumbs_arr=JSON.parse(res.data.thumbs)
						
						var rules_arr=[]
						if(res.data.rules){
							for (var key in res.data.rules) {
								if(key != 'validate_info' && res.data.rules[key]){
									res.data.rules[key]=res.data.rules[key].replace(/\n/g, '<br />');
									var params={
										content:res.data.rules[key],
										name:key
									}
									rules_arr.push(params)
								}
								
							}
						}
						
						res.data.rules_arr=rules_arr
						
						if(res.data.stocks){
							// console.log(res.data.stocks);
							var date_list=[]
							res.data.stocks.dates.map((item)=>{
								// console.log(item.date);
								date_list.push(datePrintStr(item.date))
							})
							console.log(date_list);
							res.data.stocks.date_list=date_list
						}
						
						$this.good_detail = res.data
						$this.$loading.close();
						
						// if(res.data.class_id==1101){
						// 	document.title='五星酒店游泳健身'
						// }else if(res.data.class_id==1901){
						// 	document.title='五星酒店SPA'
						// }else if(res.data.class_id==1702){
						// 	document.title='连锁健身房'
						// }
						// $this.loadStock()
					}).catch((error) => {
						console.warn(error)
						$this.$loading.close();
						$this.$toast(error.msg?error.msg:error.message);
					})
			},
			// 预约时间
			openBookTime(){
				this.$refs.bookTime.openTimePop();
			},
			updataBookTime(e){
				this.$refs.bookTime.closeTimePop();
				console.log(e);
				// datePrintStr
				var book_date_info=e
				book_date_info.date_obj=datePrintStr(e.date)
				console.log('book_date_info',book_date_info);
				this.book_date_info=book_date_info
			},
			// 预约面板
			openCreateOrder(){
				this.$refs.openCreateOrder.openOrderPop();
			},
			openTime(){this.openBookTime()},
			// 新增嘉宾
			addGuest() {
				this.guest.push('');
				this.$refs.openCreateOrder.computePrice()
			},
			// 删除嘉宾
			deleteGuest(e) {
				console.log('deleteGuest',e);
				this.guest.splice(e, 1);
				this.$refs.openCreateOrder.computePrice()
			},
		}
	}
</script>
<style lang="less" scoped="scoped">
	@vm_base: 1/750*100vw;
	.gd{
		width: 100%;
		min-height: 100vh;
		background-color: #F6F7F9;
		// padding-bottom: calc(constant(safe-area-inset-bottom) / 2+ 30*@vm_base);
		// padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 30*@vm_base);
	}
	.gd_swiper{
		width: 100%;
		height: 500*@vm_base;
	}
	.gd_body{
		width: 100%;
		position: relative;
		margin-top: -50*@vm_base;
		padding: 30*@vm_base 20*@vm_base;
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2 + 160*@vm_base);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2 + 160*@vm_base);
		background-color: #F6F7F9;
		border-radius: 16*@vm_base 16*@vm_base 0 0;
		.gd_body_title{
			width: 100%;
			font-size: 36*@vm_base;
			color: #333333;
		}
		.gd_body_address{
			width: 100%;
			background: #FFFFFF;
			border-radius: 16*@vm_base;
			padding: 30*@vm_base 20*@vm_base;
			margin-top: 30*@vm_base;
			.gd_body_address_title{
				width: 100%;
				font-size: 30*@vm_base;
				color: #333333;
			}
			.gd_body_address_stitle{
				width: fit-content;
				max-width: 100%;
				padding: 4*@vm_base 0;
				display: flex;
				justify-content: flex-start;
				align-items: center;
				font-size: 24*@vm_base;
				color: #999999;
				margin-top: 16*@vm_base;
				background-image: url(../resource/fly.png);
				background-size: auto 100%;
				background-repeat: no-repeat;
				background-position: right center;
				padding-right: 40*@vm_base;
				
				.gd_body_address_stitle_1{
					width: fit-content;
					max-width: 100%;
				}
				.gd_body_address_stitle_2{
					width: fit-content;
					padding-left: 20*@vm_base;
				}
			}
		}
		.gd_body_desc{
			width: 100%;
			background: #FFFFFF;
			border-radius: 16*@vm_base;
			padding: 30*@vm_base;
			margin-top: 20*@vm_base;
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center;
			background-image: url(../resource/good_detail_desc.png);
			.gd_body_desc_title{
				text-align: center;
				font-size: 32*@vm_base;
				color: #F77F28;
			}
			.gd_body_desc_conte{
				width: 100%;
				font-size: 28*@vm_base;
				color: #333333;
				line-height: 1.5;
				letter-spacing: 1px;
				margin-top: 30*@vm_base;
			}
		}
		.gd_body_rule{
			width: 100%;
			background: #FFFFFF;
			border-radius: 16*@vm_base;
			padding:0 30*@vm_base 30*@vm_base 30*@vm_base;
			margin-top: 20*@vm_base;
			.gd_body_rule_item{
				width: 100%;
				padding-top: 30*@vm_base;
				.gd_body_rule_item_title{
					font-size: 30*@vm_base;
					color: #333333;
				}
				.gd_body_rule_item_stitle{
					margin-top: 20*@vm_base;
					width: 100%;
					font-size: 26*@vm_base;
					color: #666666;
					line-height: 1.5;
				}
			}
		}
	}
	.gd_bottom{
		width: 100%;
		position: fixed;
		left: 0;
		bottom: 0;
		height: calc(constant(safe-area-inset-bottom) / 2 + 130*@vm_base);
		height: calc(env(safe-area-inset-bottom) / 2 + 130*@vm_base);
		padding-bottom: calc(constant(safe-area-inset-bottom) / 2);
		padding-bottom: calc(env(safe-area-inset-bottom) / 2);
		background: #FFFFFF;
		border-radius: 16*@vm_base 16*@vm_base 0 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 0 20*@vm_base 0 40*@vm_base;
		box-shadow: -4px -4px 6px rgba(243, 207, 166, 0.5);
		.gd_bottom_left{
			.gd_bottom_left_1{
				font-size: 24*@vm_base;
				color: #F77F28;
				line-height: 1.2;
			}
			.gd_bottom_left_2{
				font-size: 54*@vm_base;
				color: #F77F28;
				padding: 0 2*@vm_base;
			}
			.gd_bottom_left_3{
				font-size: 24*@vm_base;
				color: #999999;
				margin-left: 26*@vm_base;
				line-height: 1.2;
				text-decoration: line-through;
			}
		}
		.gd_bottom_right{
			width: 250*@vm_base;
			height: 80*@vm_base;
			background: linear-gradient( 319deg, #FB8027 0%, #FFA663 100%);
			border-radius: 40*@vm_base;
			font-size: 32*@vm_base;
			color: #FFFFFF;
		}
	}
</style>


// WEBPACK FOOTER //
// src/views/goods_detail.vue